import { TreeGrid } from "../lib/tree-grid";

//Refined implementation for a color tree grid.
// deprecated
export class ColorTreeGrid extends TreeGrid{
    constructor(rows:number, cols: number, canvas: HTMLCanvasElement){
        super(rows,cols,canvas); 
        this.setVisible(false);
    }

    getCanvasHeight(): number {
        return  this.canvas.clientWidth/1.5;
    }
}
